const METRICS = [
  { kpi: "60 min → <2 min", title: "Class-cover workflow", body: "Manual routing replaced with near-instant assignment." },
  { kpi: "30k → <300", title: "Weekly Zapier tasks", body: "Redesigned in Apps Script. About $700 saved monthly." },
  { kpi: "50+ projects", title: "Cross-sector delivery", body: "Across countries and industries with mixed tool stacks." },
  { kpi: "Multi-school", title: "Education systems", body: "Operational AI workflows built and supported across schools." },
];

import { forwardRef } from "react";

const ProofMetricCards = forwardRef<HTMLDivElement>((_props, ref) => {
  return (
    <div ref={ref} className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {METRICS.map((m) => (
        <article key={m.title} className="card-atk">
          <div className="text-[22px] sm:text-[26px] font-extrabold text-primary leading-tight">{m.kpi}</div>
          <h3 className="mt-3 text-[16px] font-semibold text-navy">{m.title}</h3>
          <p className="mt-1.5 text-[14.5px] text-muted-foreground leading-relaxed">{m.body}</p>
        </article>
      ))}
    </div>
  );
});
ProofMetricCards.displayName = "ProofMetricCards";
export default ProofMetricCards;
